import type { LovemoTheme } from '@/hooks/useLovemoTheme';

interface LovemoThemeToggleProps {
  theme: LovemoTheme;
  onToggle: () => void;
}

export default function LovemoThemeToggle({ theme, onToggle }: LovemoThemeToggleProps) {
  const isDark = theme === 'dark';
  const label = isDark ? '切换到白天模式' : '切换到夜间模式';

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      className="relative flex h-9 w-[58px] cursor-pointer items-center overflow-hidden rounded-full border border-background-200/80 bg-background-100 p-1 transition-colors sm:h-10 sm:w-[72px]"
    >
      <span className="flex flex-1 items-center justify-center text-[13px] text-foreground-400 sm:text-[15px]">
        <i className="ri-sun-line" aria-hidden="true" />
      </span>
      <span className="flex flex-1 items-center justify-center text-[13px] text-foreground-400 sm:text-[15px]">
        <i className="ri-moon-clear-line" aria-hidden="true" />
      </span>
      <span
        className={`absolute left-1 top-1/2 z-10 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform duration-300 dark:text-background-950 sm:h-8 sm:w-8 ${
          isDark ? 'translate-x-[22px] sm:translate-x-[32px]' : 'translate-x-0'
        }`}
      >
        <i className={`text-[13px] sm:text-[15px] ${isDark ? 'ri-moon-clear-fill' : 'ri-sun-fill'}`} aria-hidden="true" />
      </span>
    </button>
  );
}